import gsap from 'gsap'
import debounce from 'debounce'

export default () => {
  return {
    timelines: [],
    init() {
      this.setupAnimation()
      this._onResize = debounce(() => this.setupAnimation(), 300)
      window.addEventListener('resize', this._onResize)
    },
    destroy() {
      window.removeEventListener('resize', this._onResize)
      this.killTimelines()
    },
    killTimelines() {
      this.timelines.forEach(tl => tl.kill())
      this.timelines = []
    },
    setupAnimation(){
      this.killTimelines()

      const sourceElement = this.$refs.logosOriginal
      const targetElement = this.$refs.logoFader

      targetElement.innerHTML = ''

      Array.from(sourceElement.children).forEach((child) => {
        targetElement.appendChild(child.cloneNode(true))
      })

      const images = gsap.utils.toArray('.js-image', this.$refs.logoFader)

      const colCount = this.getColumnsCount()

      this.getChunks(images, colCount).forEach((images, i) => {
        const wrapper = document.createElement('div')
        wrapper.classList.add('w-full', 'flex', 'justify-center')

        this.$refs.logoFader.appendChild(wrapper)

        images.forEach(image => wrapper.appendChild(image))

        const logoTimeline = gsap.timeline({ repeat: -1, delay: i * 0.20 })
        const first = images[0]

        // Logos swap instantly (no opacity fade) on a 2s rotation; top is pinned to 0
        // so each logo aligns to the top of the fader row (h-15) regardless of its
        // default -top-6.25 class in the Twig template.
        gsap.set(first, { autoAlpha: 1, top: '0px' })

        images.forEach((image, i) => {
          const next = images[i + 1]
          if (next) {
            logoTimeline
              .set(image, { autoAlpha: 0 }, '+=2')
              .set(next, { autoAlpha: 1, top: '0px' }, '<')
          } else {
            logoTimeline
              .set(image, { autoAlpha: 0 }, '+=2')
              .set(first, { autoAlpha: 1, top: '0px' }, '<')
          }
        })

        this.timelines.push(logoTimeline)
      })
    },
    getColumnsCount() {
      return window.getComputedStyle(this.$refs.logoFader).getPropertyValue('grid-template-columns').split(' ').length
    },
    getChunks(images, columns) {
      const chunks = Array.from({ length: columns }, () => [])

      for (let i = 0; i < images.length; i++) {
        chunks[i % columns].push(images[i])
      }

      // Merge any single-item trailing chunk back into the previous one so every
      // column has something to fade between.
      for (let i = chunks.length - 1; i > 0; i--) {
        if (chunks[i].length === 1) {
          chunks[i - 1].push(chunks[i].pop())
        }
      }

      return chunks.filter(chunk => chunk.length > 0)
    },
  }
}
